import React from "react";

interface ReportingTitleProps {
    title: string;
    className?: string;
}

export const ReportingTitle: React.FC<ReportingTitleProps> = ({ title, className }) => {
    return <div className={`${className || ""} reporting-title`}><h3 className="mb-0">{title}</h3></div>
}